export default "__VITE_ASSET__66fc06d3__"